import { CurrencyAmountModel } from '@marketplace-web/currency/currency-data'

export const SELLER_INSIGHTS_TAB_NAME = 'insights'

export type SellerInsightsType = {
  isVisible: boolean
  activeItemsStats: {
    count: number
    total: CurrencyAmountModel
  }
  soldItemsStats: {
    total: CurrencyAmountModel
    period: {
      total: CurrencyAmountModel
    }
  }
}
